import { render, staticRenderFns } from "./CRadio.vue?vue&type=template&id=bbf9b8f0"
import script from "./CRadio.vue?vue&type=script&lang=js"
export * from "./CRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbf9b8f0')) {
      api.createRecord('bbf9b8f0', component.options)
    } else {
      api.reload('bbf9b8f0', component.options)
    }
    module.hot.accept("./CRadio.vue?vue&type=template&id=bbf9b8f0", function () {
      api.rerender('bbf9b8f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CRadio.vue"
export default component.exports